import { render } from "./productFeature.vue?vue&type=template&id=311a704c"
import script from "./productFeature.vue?vue&type=script&lang=js"
export * from "./productFeature.vue?vue&type=script&lang=js"

import "./productFeature.vue?vue&type=style&index=0&id=311a704c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__